import { createTheme } from '@material-ui/core/styles'
import palette from './palette'
import typography from './typography'
import spacing from './spacing'
import overrides from 'theme/overrides'
import breakpoints from './breakpoints'
import props from './props'

const theme = createTheme({
  palette,
  typography,
  spacing,
  breakpoints,
  overrides,
  props,
})

export default theme;
